import type { ReactNode } from 'react';
import {
  Command,
  CommandEmpty,
  CommandInput,
  CommandList,
} from '@/code/frontend/components/ui/command';
import { Dialog, DialogContent } from '@/code/frontend/components/ui/dialog';
import { CMDK_COMMAND_CLASSNAME } from '../constants';

interface CmdKDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  placeholder: string;
  query: string;
  onQueryChange: (value: string) => void;
  onKeyDown?: (e: React.KeyboardEvent) => void;
  onKeyUp?: (e: React.KeyboardEvent) => void;
  onPointerDown?: (e: React.PointerEvent) => void;
  children: ReactNode;
  emptyMessage?: string;
  isLoading?: boolean;
}

/**
 * Shared wrapper for the CmdK dialog with consistent styling.
 */
export function CmdKDialog({
  open,
  onOpenChange,
  placeholder,
  query,
  onQueryChange,
  onKeyDown,
  onKeyUp,
  onPointerDown,
  children,
  emptyMessage,
  isLoading,
}: CmdKDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="overflow-hidden p-0 shadow-lg">
        <Command
          shouldFilter={false}
          onKeyDown={onKeyDown}
          onKeyUp={onKeyUp}
          onPointerDown={onPointerDown}
          className={CMDK_COMMAND_CLASSNAME}
        >
          <CommandInput
            placeholder={placeholder}
            value={query}
            onValueChange={onQueryChange}
          />
          <CommandList>
            {isLoading && <CommandEmpty>Searching...</CommandEmpty>}
            {emptyMessage && !isLoading && (
              <CommandEmpty>{emptyMessage}</CommandEmpty>
            )}
            {children}
          </CommandList>
        </Command>
      </DialogContent>
    </Dialog>
  );
}
